import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentLang: 'English', // 当前语言
        isShowLangMenu: false, // 是否显示语言菜单
        name: '', // 首页姓名
        email: '', // 首页邮箱
        amazonOrderID: null, // 亚马逊订单id
        amazonProductASIN: '', // 亚马逊订单产品ASIN
        amazonProductName: '', // 亚马逊订单产品名称
        salesChannel: '', // 销售渠道
        shopID: null, // 店铺id
        giftsList: [], // 礼物列表
        giftType: null, // 选择的礼物类型 ‘实体’ 或 ‘虚拟’
        giftID: null, // 选择的礼物id
        giftOrderID: null, // 选择礼物订单id
        giftName: '', // 选择的礼物名称
        giftImage: '', // 选择的礼物封面图片
        deliverName: '', // 礼物收件人姓名
        deliverPhone: '', // 礼物收件人电话
        deliverEmail: '', // 礼物收件人邮箱
        // deliverAddress: '', // 礼物收件人地址
        deliverStreet: '', // 礼物收件人街道地址
        deliverApartment: '', // 礼物收件人公寓/单元
        deliverCity: '', // 礼物收件人城市
        deliverRegion: '', // 礼物收件人地区/州
        deliverCountry: '', // 礼物收件人国家
        deliverPostcode: '', // 礼物收件人邮编
        stepOne: {
            sex: null, // 性别
            age: null, // 年龄
            reason: null, // 原因
            otherReason: '', // 其它原因
            isDisabledInput: true, // 其它原因输入框是否可输入
            isDisabledBtnNext: true // 下一步按钮是否可用
        },
        stepTwo: {
            starNum: null, // 评分
            commentValue: '', // 评论内容
            isDisabledBtnNext: true // 下一步按钮是否可用
        }
    },
    mutations: {
        setLanguage(state, data) { // 设置语言
            state.currentLang = data
        },
        getGiftsList(state, data) { // 获取礼物列表（点击页码分页)
            state.giftsList = data
        },
        getGiftsListScroll(state, data) { // 获取礼物列表（滚动分页)
            state.giftsList = state.giftsList.concat(data)
        }
    },

});